module.exports = __webpack_public_path__ + "img/google_play.3d76a31e.png";